import Component from "./profile";

import { bindActionCreators } from "redux";
import { getUserProfile, updateUserProfile } from "../../store/actions/user";
import connect from "react-redux/es/connect/connect";
import { logout } from "../../store/actions/session";

function mapStateToProps(state) {
  const user = state.user;
  const session = state.session;

  return {
    user,
    session,
  };
}
function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    { getUserProfile, updateUserProfile, logout },
    dispatch
  );
}

export const Profile = connect(mapStateToProps, mapDispatchToProps)(Component);
